export default __webpack_public_path__ + "1.17.19/static/media/libreView-small-ar.49a1f8b1.svg";